import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import * as M from "materialize-css/dist/js/materialize";
import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-corrales',
    templateUrl: './corrales.component.html',
    styleUrls: ['./corrales.component.css']
})
export class CorralesComponent implements OnInit {

    corrales: any = [];
    nacimientos: any = [];
    user: any = {};
    idlote: string;
    prevtitle: string = ''
    title: string = ''
    lote: number = 0;
    galpon: string = '';
    current_lote: number = 0;
    cantidad_semanas: any = {};
    Loading: boolean = true
    alert_message: string;
    instance: any;

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public resource: ResourcesService,
        private _location: Location
    ) {

        let user = localStorage.getItem('user')
        this.user = JSON.parse(user);
        if (user == undefined) {
            this.router.navigate(['/']);
            return
        } else {
            this.route.paramMap.subscribe(params => {
                this.idlote = params.get('idlote');

                // TRAER ID DEL LOTE DE DONDE VIENE
                var lotes = localStorage.getItem('lotes')
                lotes = JSON.parse(lotes)
                for (let i = 0; i < lotes.length; i++) {
                    if (lotes[i]['idLote'] == this.idlote) {
                        this.current_lote = lotes[i]['idGalpon']

                        var galpones = localStorage.getItem('galpones')
                        galpones = JSON.parse(galpones)
                        for (let g = 0; g < galpones.length; g++) {
                            if (galpones[g]['idGalpon'] == this.current_lote) {
                                this.galpon = 'Galpón ' + galpones[g]['Galpon']
                            }
                        }
                    }
                }

                // TRAER TODOS LOS CORRALES
                if (this.idlote == null) {
                    this.router.navigate(['/lotes']);
                    return;
                }

                var url_corrales = resource.route + '/corrales/' + this.idlote;
                if (this.user.TipoPesaje == 2) {
                    this.prevtitle = "Nacimientos"
                    this.http.get(resource.route + '/lotes/name/' + this.idlote).subscribe(
                        (data: any) => {
                            this.title = data[0]['lote_str']
                        }
                    );
                    this.http.get(resource.routePlanta + '/nacimiento/cabecera/' + this.idlote).subscribe(
                        (data: any) => {
                            for (let i = 0; i < data.length; i++) {
                                data[i]['cloud'] = 'cloud'
                            }
                            this.nacimientos = data;
                            this.Loading = false;
                            resource.updateLocalStorageFromOnline()
                            if (this.nacimientos.length == 0) {
                                this.error("No existen nacimientos en el lote actual.")

                            }
                        },
                        error => {
                            let nacimientos = JSON.parse(localStorage.getItem('nacimientos'));
                            this.nacimientos = [];
                            for (let i = 0; i < nacimientos.length; i++) {
                                const n = nacimientos[i];
                                n.cantidad_semanas = 0;
                                for (let j = 0; j < n.semanas.length; j++) {
                                    const s = n.semanas[j];
                                    if (s.idlote == this.idlote) {
                                        n.cantidad_semanas = n.cantidad_semanas + 1;
                                    }
                                }
                                for (let j = 0; j < n.detalle.length; j++) {
                                    const d = n.detalle[j];
                                    if (d.idLote == this.idlote) {
                                        this.title = d.CodigoLote;
                                        this.nacimientos.push(n);
                                    }
                                }
                            }
                            if (this.nacimientos.length == 0) {
                                this.error("No existen nacimientos en el lote actual.")
                            }
                            this.Loading = false;
                        }
                    );
                } else {
                    this.traerCantidadSemana()
                    this.prevtitle = "Corrales"
                    this.http.get(resource.route + '/lotes/name/' + this.idlote).subscribe(
                        (data: any) => {
                            this.title = data[0]['lote']
                        }
                    );
                    this.http.get(url_corrales).subscribe(
                        (data: any) => {
                            for (let i = 0; i < data.length; i++) {
                                data[i]['cloud'] = 'cloud'
                            }
                            this.corrales = data;
                            resource.updateLocalStorageFromOnline()
                        },
                        error => {
                            let corralesStorage = localStorage.getItem('corrales')
                            let corrales = corralesStorage ? (JSON.parse(corralesStorage)) : []
                            corrales = corrales.filter(d => d.idLote == this.idlote).map(d => {
                                const corral = d.corral.startsWith('C') ? d.corral : `C${d.corral}`
                                const orden = Number(corral.substring(1))
                                return { ...d, corral, orden }
                            }).sort((a, b) => a.orden - b.orden)
                            for (let i = 0; i < corrales.length; i++) {
                                if (corrales[i]['idlote'] == this.idlote) {
                                    if (this.title == '') {
                                        this.title = corrales[i]['lote']
                                    }
                                    if (this.galpon == '' && corrales[i]['Galpon'] != undefined) {
                                        this.galpon = 'Galpón ' + corrales[i]['Galpon']
                                    }
                                    if (corrales[i]['online'] == 0) {
                                        corrales[i]['cloud'] = 'exclamation-triangle'
                                    } else {
                                        corrales[i]['cloud'] = 'cloud'
                                    }
                                    this.corrales.push(corrales[i])
                                }
                            }
                        }
                    );
                }
            });
        }
    }

    ngOnInit(): void {
    }

    traerCantidadSemana() {
        var semanas = localStorage.getItem('semanas')
        semanas = JSON.parse(semanas)
        for (let i = 0; i < semanas.length; i++) {
            if (semanas[i]['idcorral'] == '422dc5ce-e80d-442c-8762-41257b35b61c') {
            }
            // if (this.cantidad_semanas[semanas[i]['idcorral']] == undefined) {
            //     this.cantidad_semanas[semanas[i]['idcorral']] = 0
            // }
            if (semanas[i]['semana'] > this.cantidad_semanas[semanas[i]['idcorral']]
                || typeof this.cantidad_semanas[semanas[i]['idcorral']] == "undefined") {
                this.cantidad_semanas[semanas[i]['idcorral']] = semanas[i]['semana']
            }
        }
    }

    error(texto) {
        this.alert_message = texto;
        var elem = document.querySelector('#modal2');
        this.instance = M.Modal.init(elem);
        this.instance.open();
        setTimeout(() => {
            this.instance.close();
            this.regresar()
        }, 2000);
    }

    agregarCorral(idlote) {
        this.router.navigate(['/agregar-corral/' + idlote]);
    }

    goToPesaje(idcorral, idLote) {
        this.router.navigate(['/pesajes/' + idLote + "/" + idcorral]);
    }

    regresar() {
        this.router.navigate(['/lotes/' + this.current_lote]);
    }

}
